
// import { gotoPage } from '@/utils/public'
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    suggests: Array,
    selected: Number
  }
})
export default class SuggestBox extends Vue {
  suggests!: Array<string>
  private selected!: number

  adjustSelected (index: number) {
    if (this.selected !== index) return false
    const els = this.$refs[`${index}`] as HTMLElement[] | null
    if (!els || els.length !== 1) return true
    const el = els[0]

    const suggestDOM = this.$refs.suggestDOM as HTMLElement

    let item = el.offsetTop - suggestDOM.scrollTop
    let box = 0

    if (item < box) {
      suggestDOM.scrollTop -= box - item
      return true
    }

    item += el.offsetHeight
    box += suggestDOM.offsetHeight

    if (item > box) {
      suggestDOM.scrollTop -= box - item
    }

    return true
  }
}
